import { Star, Shield } from 'lucide-react';
import { Badge } from '../../ui';
import { companyInfo } from '../../../data';

export function Hero() {
    const imagePath = `${process.env.PUBLIC_URL || ''}/images/sediu-insurance.jpg`;

    return (
        <section className="relative overflow-hidden">
            {/* Background Image with Overlay */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                    backgroundImage: `url("${imagePath}")`,
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-br from-main-color/85 via-main-color/75 to-blue-900/85" />
            </div>

            {/* Content */}
            <div className="relative container mx-auto px-4 py-16 md:py-24">
                <div className="max-w-3xl mx-auto text-center">
                    {/* Partner Badge */}
                    <div className="flex justify-center mb-6">
                        <Badge variant="primary" className="bg-white/20 text-white backdrop-blur-sm border border-white/30">
                            <Shield className="w-4 h-4 mr-1 text-white" />
                            Partener Renomia - Peste 20 ani experienta
                        </Badge>
                    </div>

                    {/* Heading */}
                    <h1 className="text-3xl md:text-5xl font-bold text-white font-font-s mb-4 leading-tight">
                        Asigurari pentru
                        <span className="block text-white/90">tot ce conteaza</span>
                    </h1>

                    {/* Subtitle */}
                    <p className="text-lg md:text-xl text-white/80 font-font-s mb-8 max-w-2xl mx-auto">
                        Solutii personalizate de asigurare pentru persoane fizice si juridice. Consiliere gratuita si
                        asistenta profesionala.
                    </p>

                    {/* Google Reviews */}
                    <div className="flex justify-center mb-8">
                        <a
                            href={companyInfo.socialLinks.googleReviews}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-white/90 hover:text-white hover:bg-white/20 transition-all"
                        >
                            <div className="flex -space-x-1">
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <Star
                                        key={i}
                                        className="w-4 h-4 fill-yellow-400 text-yellow-400"
                                    />
                                ))}
                            </div>
                            <span className="text-sm font-medium">Vezi recenzii Google</span>
                        </a>
                    </div>

                    {/* Quick Stats */}
                    <div className="grid grid-cols-3 gap-4 max-w-md mx-auto">
                        <div className="text-center">
                            <div className="text-2xl md:text-3xl font-bold text-white">20+</div>
                            <div className="text-xs md:text-sm text-white/60">Ani experienta</div>
                        </div>
                        <div className="text-center border-x border-white/20">
                            <div className="text-2xl md:text-3xl font-bold text-white">12+</div>
                            <div className="text-xs md:text-sm text-white/60">Tipuri asigurari</div>
                        </div>
                        <div className="text-center">
                            <div className="text-2xl md:text-3xl font-bold text-white">2</div>
                            <div className="text-xs md:text-sm text-white/60">Locatii Botosani</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
